<div class="loading-container" *ngIf="loading">
  <div class="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</div>
<div class="content-container" *ngIf="!loading">
  <div class="header-container">
    <div class="header-content">
      <h2 class="headline-highlight">Auto Pay</h2>
      <div class="mat-toggle" *ngIf="!disableButton">
        <mat-slide-toggle [(ngModel)]="autopayToggle" (change)="onToggleChange()">
           {{ toggleText }}
        </mat-slide-toggle>

      </div>
    </div>
  </div>

  <div class="mt-3 success-box" *ngIf="successMessage">
    <!-- <app-notification-box [isSuccess2]="true">
      <div>Enable Auto Pay to set it and forget it. We'll change your Primary Auto Pay Card on the billing date. If Auto Pay is enabled, the remaining balance will be paid automatically.</div>
    </app-notification-box> -->
  </div>
  
  
<div class="box-border">
   <p>Enable Auto Pay to set it and forget it. We'll charge your Primary Auto Pay Card on the billing date. If Auto Pay is enabled, the remaining balance will be paid automatically.
    </p>
    <div cdkDropList class="drag-and-drop-items" >
        </div>
</div>


<div class="box-border" *ngIf="hasPaymentMethods || autopayToggle">

    <div *ngIf="!hasPaymentMethods && autopayToggle">
        <h4 class="mt-2" style="font-weight: bold;">Primary Auto Pay Card</h4>
        <p class="text-danger">Set Primary Auto Pay Card Method for Auto Pay</p>
        
        <div class="add-new mt-3">
            <a (click)="addNewPaymentMethod()">+ Add New Payment Method</a>
        </div>
    </div>
    
<ng-container *ngIf="hasPaymentMethods || primaryAutoPayCard">
    <h4 class="mt-2">Primary Auto Pay Card</h4>

    <p class="text-danger" *ngIf="!isPrimaryAutoPay">
        Set Primary Auto Pay Card Method for Auto Pay
    </p>
    <hr *ngIf="!isPrimaryAutoPay">

    <!-- ✅ Only show this if a primary card exists -->
    <div class="primary-card" *ngIf="primaryAutoPayCard?.cardType">
        <span class="bank-icons">
            <img class="pay-icon" [src]="getpayintoken.getcardImage(primaryAutoPayCard.cardType, '')">
        </span>
        <div class="info">
            <span>{{ primaryAutoPayCard.cardType }} | **** {{ primaryAutoPayCard.last4Digits }}</span>
            <div>Set up by {{ primaryAutoPayCard.ccHolderName }}</div>
        </div>
        <div class="primary-label">
            <span class="primary-box">Primary</span>
        </div>
    </div>

    <p class="instruction">
        To change your AutoPay method, select your preferred card below and click Confirm Update.
To add, edit, or remove cards, visit Manage Payment Methods.
    </p>

    <div *ngFor="let cctoken of cctokens" class="tokendiv">
        <input type="radio"
               class="form-check-input"
               [(ngModel)]="selectedtoken"
               [value]="cctoken.userCreditCardId"
               [disabled]="!autopayToggle && !isWaitingForOffConfirmation" />
        <span class="bank-icons">
            <img class="pay-icon" [src]="cctoken.cardImg">
        </span>
        <div class="info">
            <span>{{ cctoken.creditCardType }} | **** {{ cctoken.last4 }}</span>
            <div>{{ cctoken.ccHolderName }}</div>
        </div>
        <div class="edit-link">
            <a (click)="editPaymentMethod(cctoken)">Edit</a>
        </div>
    </div>

    <!-- <div class="add-new">
        <a (click)="addNewPaymentMethod()">+ Add New Payment Method</a>
    </div> -->
</ng-container>

</div>


 <!-- confirm update button -->
<div class="button-container mt-3" *ngIf="canUpdateOrConfirm">
 
  <button 
  class="dw-primary-button icon-right" 
  (click)="openAutoPayDialog()" 
  [disabled]="buttonLoading || (!autopayToggle && !isWaitingForOffConfirmation) || (autopayToggle && !selectedtoken)" 
>
  {{ mainActionButtonText }} 
  <mat-icon class="black">keyboard_arrow_right</mat-icon> 
</button>
    
    <button *ngIf="buttonLoading" class="btn-balance mdc-button mdc-button--raised mat-mdc-raised-button primary" disabled>Processing...</button>
</div>

</div>
